import { render, staticRenderFns } from "./lostRecord.vue?vue&type=template&id=502576b6&"
import script from "./lostRecord.vue?vue&type=script&lang=js&"
export * from "./lostRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports